<div class="active-festival p-fluid pb-4 mb-6">
  <p class="text-sm mb-1 mt-2 font-bold">Aktives Fest</p>
  <p-select
    [options]="festivalOptions()"
    [ngModel]="selectedValue()"
    (onChange)="setSelectedFestival($event)"
    optionLabel="name"
    optionValue="value"
    placeholder="Fest Auswahl"
    [showClear]="false"
    [disabled]="isPending()"
  ></p-select>
</div>
